import {
    IEndCondition,
    IPauseRequest,
    IPausePreview,
    IPauseResult,
    IRepeatSeriesCard,
} from 'models';
import tokenInstance from 'utils/axiosInstance/tokenInstance';

const BASE = '/focus-sessions/repeat';

const list = async (): Promise<IRepeatSeriesCard[]> => {
    const response = await tokenInstance().get(`${BASE}/`);
    return response.data;
};

const get = async (id: number): Promise<IRepeatSeriesCard> => {
    const response = await tokenInstance().get(`${BASE}/${id}`);
    return response.data;
};

const pausePreview = async (body: IPauseRequest): Promise<IPausePreview> => {
    const response = await tokenInstance().post(`${BASE}/pause/preview`, body);
    return response.data;
};

const pause = async (body: IPauseRequest): Promise<IPauseResult> => {
    const response = await tokenInstance().post(`${BASE}/pause`, body);
    return response.data;
};

const resume = async (id: number): Promise<IRepeatSeriesCard> => {
    const response = await tokenInstance().post(`${BASE}/${id}/resume`);
    return response.data;
};

const reactivate = async (
    id: number,
    ends?: IEndCondition,
): Promise<IRepeatSeriesCard> => {
    const response = await tokenInstance().post(
        `${BASE}/${id}/reactivate`,
        ends ?? {},
    );
    return response.data;
};

const remove = async (id: number): Promise<void> => {
    const response = await tokenInstance().delete(`${BASE}/${id}`);
    return response.data;
};

export const RepeatSeriesService = {
    list,
    get,
    pausePreview,
    pause,
    resume,
    reactivate,
    remove,
};
